var _path, _path2, _g, _path3, _path4, _path5, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicencePlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 44,
    viewBox: "0 0 201 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.675C0.25 3.26464 3.01464 0.5 6.425 0.5H35.25V43.5H6.425C3.01464 43.5 0.25 40.7354 0.25 37.325V6.675Z",
    fill: "#2B4C9C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.675C0.25 3.26464 3.01464 0.5 6.425 0.5H35.25V43.5H6.425C3.01464 43.5 0.25 40.7354 0.25 37.325V6.675Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.75 6.675C-1.75 2.16007 1.91007 -1.5 6.425 -1.5H35.25V2.5H6.425C4.11921 2.5 2.25 4.36921 2.25 6.675H-1.75ZM35.25 45.5H6.425C1.91007 45.5 -1.75 41.8399 -1.75 37.325H2.25C2.25 39.6308 4.11921 41.5 6.425 41.5H35.25V45.5ZM6.425 45.5C1.91007 45.5 -1.75 41.8399 -1.75 37.325V6.675C-1.75 2.16007 1.91007 -1.5 6.425 -1.5V2.5C4.11921 2.5 2.25 4.36921 2.25 6.675V37.325C2.25 39.6308 4.11921 41.5 6.425 41.5V45.5Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6447 7H9.85522V37H25.6447V7Z",
    fill: "url(#pattern0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 0.5H194.075C197.485 0.5 200.25 3.26464 200.25 6.675V37.325C200.25 40.7354 197.485 43.5 194.075 43.5H35.25V0.5Z",
    fill: "#F0B504"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 0,
    width: 166,
    height: 44
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 0.5H194.075C197.485 0.5 200.25 3.26464 200.25 6.675V37.325C200.25 40.7354 197.485 43.5 194.075 43.5H35.25V0.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.25 -1.5H194.075C198.59 -1.5 202.25 2.16007 202.25 6.675H198.25C198.25 4.36921 196.381 2.5 194.075 2.5H35.25V-1.5ZM202.25 37.325C202.25 41.8399 198.59 45.5 194.075 45.5H35.25V41.5H194.075C196.381 41.5 198.25 39.6308 198.25 37.325H202.25ZM194.075 -1.5C198.59 -1.5 202.25 2.16007 202.25 6.675V37.325C202.25 41.8399 198.59 45.5 194.075 45.5V41.5C196.381 41.5 198.25 39.6308 198.25 37.325V6.675C198.25 4.36921 196.381 2.5 194.075 2.5V-1.5Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_3",
    transform: "scale(0.02 0.0105263)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_3",
    width: 50,
    height: 95,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABfCAMAAACdi2QHAAAAt1BMVEUAAAD/////////////////0AD/zQD/0AD/zwD/////zAD/zQD/zgD/zgD/zgD/zAD/zQD/zQD/zQD/zAD/zgD/zwD/////zQD/zgD/zgD/zgD/zgD/0QD/0QD/0gD/////zAD/////zAD/zwD/zgD/zQD/zgD/zgD/zwD/zwD/0AD/////zAD/zAD/zQD/zQD/zQD/zQD/zgD/1QD/zQD/zAD/zwD/zwD/////zgD/////////zAANYJ8TAAAAO3RSTlMAIndmRAPMDAeZ+354ch7x7NjQ50hB7pKGbGcxJhAK3cO7mV1UTzk1IxkVEfW+ubCnn4wF4I97ZFUpqrhCPwUAAAJRSURBVFjDzJRtb4IwFIX7paUplHeCCBqiiGh8n86YnP//u6ZpGMu22prsw04CtOU8ub3N7SU6VRV5VZ73mn8ivSjy5MTC+tYQpWUEnFui1EyfIOmuHxWA7Mf7hc5PZc5EflFp78ZXhXeXfMNySTUZ7IEkVfiNkErZsgTYa7PKgP3P1QOQEp1OXsmc74tTtpS5FvHvhvX3xbXz+PEnGtuYrl8nZWSDxO0QYlbjOFs+95ezI+pZQZT4BQgXxKBFCOS8n90gYmIUEyiHQnf9XWUi/K3vuZ+zFSF0bULW9GH873p73epaE72120xtCR7c7u95HSHeZjZAtmWI6jkhjUCoCKPaEOJOEB9hwO0QGoboHnVc8FFqh2QnPn7UsqMes3rrf5fzsomfbJDT1ypJQ2omaDL0h+IcIIlNHYYlCBL5GQSIVsaLHANDmEywxLyzcyyGKpEt9ZYmonRp6w2JqUcjg2lCNItarUa/3l7/CVJEv3Z8qd3sKBDYsErNHEd9O7aBCEa6LjQH6r6QmoYoTbfAleg0D1isAnJ+OHCuDoixYKxF3juqUnWOAHBw1JFQ37XqcR/t0E0KgzAUReEXjeLbgHQm6dRRJxKs+19XcwehtLTCGQq5E//yccDjuBnbfRwfTAzbNG2DtbW1XWbdU+veL2J5DKb1uvtL5hUSZSBxZRgJyjBiygRGlHFGzPWVkXVWBpD6FxhRZgekXiMjyiRA6oHIiC3KMKITmRFlFkhyue0ZsaQMI1EZQGomM6JCYsT28gRJ4MT8g3zNf5LAifk5eQEQP3yQxM05hwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicencePlate);
export default __webpack_public_path__ + "static/media/licencePlate.4c1a069e693f477b00f78752e21804b9.svg";
export { ForwardRef as ReactComponent };